export default {
      id: "icon_nater-usage",
      viewBox: "0 0 48 12",
      url: __webpack_public_path__ + "sprite.svg#icon_nater",
      toString: function () {
        return this.url;
      }
    }